<template>
    <div class="main-body">
        <div class="header">
            服务类订单
        </div>
        <div class="out">

          <div class="search2">
              <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList'>
                  <template slot="daterange">
                      <Daterange :startTime="searchForm.startTime" :endTime="searchForm.endTime" @dataChange='dataChange'></Daterange>
                  </template>
              </Search>
              <div style="clear: both;"></div>
          </div>

          <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">
               <el-table-column prop="serialNumber" label="订单流水号" width="300"></el-table-column>
  <el-table-column prop="user.name" label="老人姓名" width="85"></el-table-column>
  <el-table-column prop="user.phone" label="手机号" width="150"></el-table-column>
  <el-table-column prop="orderGoods.goodsName" label="商品名称"
                   width="150"></el-table-column>
  <el-table-column prop="orderGoods.goodsPrice" label="单价(元)"
                   width="105"></el-table-column>

  <el-table-column prop="orderGoods.number" width="105" label="购买数量"></el-table-column>
  <el-table-column prop="price" label="总价(元)" width="105"></el-table-column>
  <el-table-column prop="orderFrom" :formatter="getOrderFrom" width="105" label="订单来源" ></el-table-column>
  <el-table-column
      prop="status"
      :formatter="statuss"
      width="105"
      label="订单状态">
  </el-table-column>

  <!-- <el-table-column prop="listOrderGoodsDTO[0].planTime" :formatter="timefilter" width="200"
                   label="预约时间"></el-table-column> -->
  <el-table-column prop="createTime" :formatter="timefilter" width="200"
                   label="下单时间"></el-table-column>
  <el-table-column
      prop="orderType"
      :formatter="statusTitle"
      label="订单类型" width="150">
  </el-table-column>
  <el-table-column prop="serveName" label="服务人员" width="85"></el-table-column>
  <el-table-column prop="orderServe.startTime" :formatter="getSETime" width="200"
                   label="服务开始时间"></el-table-column>
  <el-table-column prop="orderServe.endTime" :formatter="getSETime" width="200"
                   label="服务结束时间"></el-table-column>
              <el-table-column
                      prop="orderType"
                      :formatter="statusTitle"
                      label="订单类型" width="150">
              </el-table-column>


              <!-- <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column> -->

              <el-table-column fixed="right" label="操作" width="150">
                  <template slot-scope="scope">
                      <el-button type="primary" size="mini" @click="openQr(scope.row)">订单二维码</el-button>
<!--                                <el-button type="primary" size="small" :loading="loading"  @click="deleteOrder(scope.row)" >删除</el-button>-->
                  </template>
              </el-table-column>


          </el-table>
          <div class="page">
              <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
              <div style="float: left;">
                  <el-pagination small
                          background
                          layout="prev, pager, next"
                          :total="totalItems"
                          :page-size="20"
                          :current-page.sync="currentPage"  @current-change="current_change">
                  </el-pagination>
              </div>
              <div style="clear: both;"></div>
          </div>

          <el-dialog
              title="二维码"
              :visible.sync="OpenQrCode"
              width="30%"
              class="QRCode">
            <div class="canvas-code" id="qrcode" ></div>
          </el-dialog>


        </div>

        <!-- <Add ref="myAdd" v-show="showModalAdd" v-bind:goodsClassValue="goodsClassValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:goodsClassValue="goodsClassValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr, timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import QRCode from "qrcodejs2";
    import Daterange from "@/components/Daterange";
    import Search from "@/components/Search";
    export default {
        name: "Role",
        data() {
            return {
              status1:[{value: -1,label: '全部状态'},
                {value: 11,label: '待接单'},
                {value: 13,label: '服务中'},
                {value: 14,label: '服务完成'},
                {value: 15,label: '交易取消'},
                {value: 16,label: '已评价'}
              ],
                OpenQrCode: false,
                loading: false,
                showModalAdd: false,
                showModalEdit: false,
                tableData: null,
                goodsClassCode: '',
                businessCode: '',
                datetimerangeValue: '',
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                imgUrl: this.$imgUrl,
                th: this.$store.state.tableHeight,
                goodsClassValue: [],
                orderCode:'',
                orderBusinessCode:'',
                zoneValue: [],
                searchForm:{
                    name: '',
                    phone: '',
                    status:-1,
                    startTime:'',
                    endTime:''
                },
                searchData:''
            }
        },
        components:{
            Daterange,Search
        },
        created() {
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        methods: {
            init(){
                this.searchData=[
                    {span:12,name:'老人姓名',value:'name',type:'input'},
                    {span:12,name:'手机号',value:'phone',type:'input'},
                    {span:12,name:'状态',value:'status',type:'select',options:this.status1},
                    {span:24,name:'起止时间',width:495,value:'daterange',type:'slot'},
                ]
                this.searchForm.endTime=timefilters(new Date()).slice(0,10)
                this.searchForm.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24*30)).slice(0,10)
            },
            dataChange(val){
                this.searchForm.startTime=val[0]
                this.searchForm.endTime=val[1]
            },
            getZoneValue(val) {
                this.zoneCode = val
            },
            openQr(row){
                this.OpenQrCode=true;
                if(document.getElementById("qrcode")){
                    document.getElementById("qrcode").innerHTML = "";
                }

                this.$nextTick (function () {
                    this.qrcodeInit(row);
                })
            },
            getOrderFrom(row){
      return  row.orderFrom=='xiaole'?'小乐下单':'app下单'
    },
            //日期格式
            timefilter(row, column, cellValue) {
                if (cellValue) {
                    return timefilters(cellValue)
                }
            },
            getSETime(row, column, cellValue) {
                if (cellValue) {
                    var time = timefilters(cellValue);
                    if (time == '1970-01-01 08:00:00') {
                        return ''
                    } else {
                        return timefilters(cellValue)
                    }
                }
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },

            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },
            deleteOrder(row){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "OrderBusiness/deleteOrder",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        orderBusinessCode:row.orderBusinessCode
                    }
                }).then((response) => {
                    if (response.data.error == 0) {
                        this.loading=false;
                        this.getList();
                    } else if (response.data.error == 1) {
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },




            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.loading=true;
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "OrderBusiness/PageOrderForServe",
                    data:data
                }).then((response) => {
                    this.loading=false;
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.orderCode=this.tableData.orderCode;
                    } else if (response.data.error == 1) {
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.loading=false;
                    console.log(error);
                });
            },
            statusTitle(row, column, cellValue) {
                return this.allStatus(cellValue, ["", '普通商品订单', '社会化服务订单', '政府购买服务订单']);
            },
            isSchedules(row, column, cellValue) {
                return this.allStatus(cellValue, ['否', '是']);
            },
            statuss(row, column, cellValue) {
                return this.allStatus(cellValue, ['待付款', '待发货', '待收货', '交易成功', '退款中', '交易关闭', '交易取消', '已评价', "", "", '待付款', '待接单', '已接单', '服务中', '服务完成', '交易取消', '已评价']);
            },
            allStatus(row, status) {
                for (var i in status) {
                    if (i == row) {
                        return status[i]
                    }
                }
                return "其它";
            },

            //  生成二维码
            qrcodeInit (row) {
                console.log(row)
                console.log(row.orderBusinessCode)
                new QRCode('qrcode', {
                    width: 250,
                    height: 250,        // 高度
                    text:  row.orderBusinessCode,   // 二维码内容
                    colorDark : "#000000",
                    colorLight : "#ffffff",
                    correctLevel : QRCode.CorrectLevel.H
                })
            },

        }
    }
</script>

<style scoped>



    .QRCode{
        text-align: center;
        width: 1000px;
        margin-left: 400px;
        margin-top: 150px;
    }

</style>
